import { DepictClient } from "@/lib/depict-client/DepictClient"
import { ListingApiService } from "@/lib/depict-client/services/ListingApiService"
import { OtherApiService } from "@/lib/depict-client/services/OtherApiService"
import { RecommendationsApiService } from "@/lib/depict-client/services/RecommendationsApiService"
import { SearchApiService } from "@/lib/depict-client/services/SearchApiService"
import { ClientFetchService } from "@/lib/http/ClientFetchService"
import logger from "@/lib/logger/logger-init"
import { depictClientConfig } from "./interfaces/IDepictClientConfig"

const clientFetchService = new ClientFetchService(depictClientConfig, logger)

const searchApiService = new SearchApiService(clientFetchService, logger)

const listingApiService = new ListingApiService(clientFetchService)

const recommendationsApiService = new RecommendationsApiService(clientFetchService)

const otherApiService = new OtherApiService(clientFetchService)

const depictClientOnlyClient = new DepictClient(
    searchApiService,
    listingApiService,
    recommendationsApiService,
    otherApiService
)

export default depictClientOnlyClient
